import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VdiComponent } from './vdi.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: VdiComponent }
    ])
  ],
  exports: [RouterModule]
})
export class VdiRoutingModule { }
